module.exports = __webpack_public_path__ + "img/HABANERO.3ed230d0.png";